import type { CashFlowApAgingFilterSummary, CashFlowArAgingFilterSummary } from "./cashFlowApi";

function formatImportTimestamp(iso: string | null | undefined): string {
  if (iso == null || iso.trim() === "") {
    return "—";
  }
  const parsed = new Date(iso.includes("T") ? iso : `${iso.slice(0, 10)}T12:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return iso;
  }
  return parsed.toLocaleString();
}

export function apAgingImportHoverHint(filter: CashFlowApAgingFilterSummary | null | undefined): string {
  if (filter == null) {
    return "No accounts payable aging import yet. Upload QuickBooks A/P Aging Detail CSV to filter GIPI/TSH outflows.";
  }
  const asOf =
    filter.as_of_date != null && filter.as_of_date.trim() !== ""
      ? filter.as_of_date
      : "report date unknown";
  return [
    `Last import: ${formatImportTimestamp(filter.imported_at)}`,
    `Report as of ${asOf} · ${filter.open_gipi_tsh_count} open GIPI/TSH bills`,
    `File: ${filter.filename}`,
  ].join(". ");
}

export function arAgingImportHoverHint(filter: CashFlowArAgingFilterSummary | null | undefined): string {
  if (filter == null) {
    return "No accounts receivable aging import yet. Upload QuickBooks A/R Aging Detail CSV to filter GOSI inflows.";
  }
  const asOf =
    filter.as_of_date != null && filter.as_of_date.trim() !== ""
      ? filter.as_of_date
      : "report date unknown";
  return [
    `Last import: ${formatImportTimestamp(filter.imported_at)}`,
    `Report as of ${asOf} · ${filter.open_gosi_count} open GOSI invoices`,
    `File: ${filter.filename}`,
  ].join(". ");
}
